import * as React from "react";
import CommentModel from "../models/CommentModel";
import Context from "./Context";
import "./CommentDelete.styl";
import CommentTooltip from "./CommentTooltip";

export default class CommentDelete extends React.PureComponent<{
    comment: CommentModel
}> {

    public render(): React.ReactNode {
        const comment = this.props.comment;
        return (
            <Context.Consumer>
                {({translate, dispatch}) => (
                    <div className="Discussion-CommentDelete-Root" onClick={() => {
                        dispatch("delete", comment.getCommentId());
                    }}>
                        <CommentTooltip label={translate("TOOLTIP_DELETE")}/>
                        <div className="Discussion-CommentDelete-Icon"/>
                    </div>
                )}
            </Context.Consumer>
        );
    }

}